import React, {useState, useEffect} from 'react';
import {getCodexInfo, getCodexInfoFromSurface, getCodexInfoFromCanvas, getCodexInfoFromManifest} from '../Codex/queries'
import {runQuery} from '../utils'
import { auth } from '../Comments/firebase';


interface MyComponentProps {
  resourceid: string,
  codexResourceType?: string,
}

export const CodexInfo: React.FC<MyComponentProps> = (props) => {

  const [codexTitle, setCodexTitle] = useState<string>("")
  const [topLevels, setTopLevels] = useState<any>({})

    const retrieveCodexInfo = (id: string, type:string) => {
      let codexInfo = undefined
      if (type === "surface"){
        codexInfo = runQuery(getCodexInfoFromSurface(id))
      }
      else if (type === "canvas"){
        codexInfo = runQuery(getCodexInfoFromCanvas(id))
      }
      else if (type === "manifest"){
        codexInfo = runQuery(getCodexInfoFromManifest(id))
      }
      else{
        codexInfo = runQuery(getCodexInfo(id))
      }
      codexInfo.then((d) => {
        const data = d.data.results.bindings
        
        const codexTitle = data[0].codex_title?.value
        
        const topLevels = {}
        data.forEach((d) => {
          const topLevel = d.toplevel.value
          if (!topLevels[topLevel]){
            topLevels[topLevel] = {
              title: d.toplevel_title.value,
              author: d.author.value,
              authorTitle: d.authorTitle.value
            }
          }
        })
        setTopLevels(topLevels)
        setCodexTitle(codexTitle)
       
        })
    }
    useEffect(() => {
      retrieveCodexInfo(props.resourceid, props.codexResourceType || "codex")
      // eslint-disable-next-line
    }, [props.resourceid])

    return(
      <div>
      <p>{codexTitle}</p>
      <div>
        <p>Contains:</p>
      {Object.keys(topLevels).length > 0 && Object.keys(topLevels).map((key) => {
        return (
            <p key={"ci-" + key}>{topLevels[key].title} by {topLevels[key].authorTitle}</p>
        );
      })
    }
      </div>
      </div>
    )
}